export default __webpack_public_path__ + "static/media/SAS Alert Tone 15.907000a8.wav";